import { ActionTypes } from "../action-type";

const initialState = {
    avatars:[]
}

export const getAllAvatarReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.ALLMEMBER:
            return {...state,avatars:action.payload}
    
    default:
        return state;
    }
}